export const normalizeString = (value: number | string | undefined) => {
  let stringified;
  if (typeof value === 'string') {
    stringified = value.trim();
  }
  if (typeof value === 'number') {
    stringified = value.toString().trim();
  }
  return stringified || '---';
};
